import { useState } from "react";
import Modal from "../../../../components/common/modal/Modal";
import ButtonComponent from "../../../../components/common/button/Button";


export const RejectWorkFlowItem = ({ disabledRejectButton, onClickRejectHandler, setBulkPDTDisabled, setBulkPDTValue }) => {

    const [openRejectModal, setOpenRejectModal] = useState(false);

    const onClickRejectButton = () => {
        setOpenRejectModal(true);
    };
    const closeRejectModal = () => {
        setOpenRejectModal(false);
    };

    const onClickSubmitReject =()=>{
        setOpenRejectModal(false);
        onClickRejectHandler();
        if (typeof setBulkPDTDisabled === 'function') {
            setBulkPDTDisabled(true);
        }
        if (typeof setBulkPDTValue === 'function') {
            setBulkPDTValue("");
        }
    }

    return (
        <>
            <ButtonComponent
                maxWidth="230px"
                label="Reject"
                bgColor="black"
                color="white"
                onClick={onClickRejectButton}
                disabled={disabledRejectButton}
            />
            <Modal
                className="rejectModal_cls"
                open={openRejectModal}
                handleClose={closeRejectModal}
                title="Reject line items"
                action={
                    <RejectWorkFlowFooter
                    closeRejectModal={closeRejectModal}
                    onClickSubmitReject={onClickSubmitReject}
                />
                }
                content={
                    <RejectWorkFlowContent />
                }
                maxWidth="100px"
            />

        </>
    )
}

const RejectWorkFlowFooter = ({ closeRejectModal, onClickSubmitReject }) => {

    return (
        <div className='footer-btn-wrapper rejectWorkFlowFooter'>
            <ButtonComponent
                maxWidth="170px"
                label={"Cancel"}
                type="primary"
                onClick={closeRejectModal}
            />
            <ButtonComponent
                maxWidth="170px"
                label={"Reject"}
                bgColor="black"
                color="white"
                onClick={onClickSubmitReject}
            />
        </div>
    );
};
const RejectWorkFlowContent = () => {

    return (
        <div className='rejectWorkFlowContent'>
           <p>Warning - you are rejecting for all the selected line item</p>
        </div>
    );
};